<template>
  <div :class="[$style.item, $style[`item_${data.color}`]]">
    <div :class="$style.tag">
      {{ data.name }}
      <span>{{ data.title }}</span>
    </div>
    <div :class="$style.tip">
      <div>{{ data.tip }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="less" module>
@item-size: 0.42rem;
@item-pole-width: 0.03rem;
@item-pole-height: 0.25rem;
@item-pole-top: 0.35rem;
@tag-size: 0.32rem;
@tag-left: 0.42rem;

.item {
  .size(@item-size);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: @laptop-width) {
    font-size: 12px;
  }

  // 杆子
  &::before {
    .size(@item-pole-width, @item-pole-height);
    content: '';
    position: absolute;
    top: @item-pole-top;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-color: #3f3f3f;
  }

  // 光圈
  &::after {
    .size(100%);
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100%;
    animation: pulse 0.5s infinite;
  }

  &_green::after {
    background-color: fade(#51ab77, 10%);
  }

  &_orange::after {
    background-color: fade(#ff7611, 10%);
  }

  &_blue::after {
    background-color: fade(#387ed8, 10%);
  }

  &:hover {
    &::after {
      animation: none;
    }
  }
}

@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.2, 1.2, 1.2);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

.tag {
  .size(@tag-size);
  z-index: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  color: #fff;
  user-select: none;

  span {
    position: absolute;
    top: 0.1rem;
    left: 0;
    padding-left: @tag-left;
    color: #3f3f3f;
    white-space: nowrap;
  }

  .item_green & {
    background-color: #51ab77;
  }

  .item_orange & {
    background-color: #ff7611;
  }

  .item_blue & {
    background-color: #387ed8;

    span {
      left: -5.8em;
      padding-left: 0;
    }
  }
}

.tip {
  .size(2.75rem, 1.24rem);
  display: none;
  position: absolute;
  top: -1.44rem;
  left: -1.16rem;

  @media screen and (max-width: @tablet-width) {
    width: 3.75rem;
    left: -1.16rem - 0.5;
  }

  > div {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.12rem 0.2rem;
    border-radius: 0.05rem;
    line-height: 1.8;
  }

  .item:hover & {
    display: block;
    transform-origin: 50% 100%;
    animation: bounceInUp 0.3s both;
  }

  @keyframes bounceInUp {
    from {
      transform: scale(0);
    }

    to {
      transform: scale(1);
    }
  }

  &::after {
    .size(0.16rem);
    content: '';
    position: absolute;
    bottom: -0.08rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: rotate(45deg);
  }

  .item_green & {
    color: #2e8b6b;

    > div,
    &::after {
      background-color: fade(#dbffef, 80%);
    }
  }

  .item_orange & {
    color: #ff7611;

    > div,
    &::after {
      background-color: fade(#ffeddb, 80%);
    }
  }

  .item_blue & {
    color: #376db1;

    > div,
    &::after {
      background-color: fade(#e0ecff, 80%);
    }
  }
}

@media screen and (max-width: @mini-width) {
  .item {
    .size(@item-size * @develop-mini);
    font-size: 0.3rem;

    // 杆子
    &::before {
      .size(@item-pole-width * @develop-mini, @item-pole-height * @develop-mini);
      top: @item-pole-top * @develop-mini;
    }
  }

  .tag {
    .size(@tag-size * @develop-mini);

    span {
      padding-left: @tag-left * @develop-mini;
    }
  }
}
</style>
